export interface ContactMessage {
  user_name: string;
  user_email: string;
  message: string;
}

export function validateMessage(message: ContactMessage): string | undefined {
  if (message.user_name.trim().length < 2 || message.user_name.length > 100)
    return "Please enter a name between 2 and 100 characters.";
  if (
    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(message.user_email.trim()) ||
    message.user_email.length > 254
  )
    return "Please enter a valid email address.";
  if (message.message.trim().length < 10 || message.message.length > 5000)
    return "Please enter a message between 10 and 5,000 characters.";
}

export class ContactError extends Error {
  constructor(
    public readonly status: number,
    public readonly detail: string,
  ) {
    super(detail);
    this.name = "ContactError";
  }
}

/** EmailJS browser identifiers are public. Never put private tokens here. */
export async function sendMessage(message: ContactMessage): Promise<void> {
  const invalid = validateMessage(message);
  if (invalid) throw new ContactError(400, invalid);
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 15000);
  try {
    const response = await fetch(
      "https://api.emailjs.com/api/v1.0/email/send",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        signal: controller.signal,
        body: JSON.stringify({
          service_id:
            process.env.REACT_APP_EMAILJS_SERVICE_ID || "service_8zzl7hm",
          template_id:
            process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "template_hex2yqh",
          user_id:
            process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "nyHHQfJq0ChA7-Tot",
          template_params: message,
        }),
      },
    );
    if (!response.ok)
      throw new ContactError(response.status, await response.text());
  } finally {
    window.clearTimeout(timeout);
  }
}

export function contactErrorMessage(error: unknown): string {
  if (error instanceof ContactError) {
    if (error.status === 429)
      return "Too many requests. Please wait a minute, or open your email app below.";
    if (error.status >= 400 && error.status < 500)
      return "The email service is unavailable. Your message is still here; open your email app below to send it directly.";
  }
  return "Your message could not be confirmed as sent. Please try again later or open your email app below.";
}
